import { useCallback } from "react";

import {
  QA_ADVANTAGES_MODAL_TAB,
  UI_MOLECULE_SWIPER_SLIDES,
} from "../../_common/modules/Data/static";
import useGAViewScreen from "../../_common/modules/fe-modules/GA/useGAViewScreen";
import useGA from "../../_common/modules/fe-modules/GA/useGA";
import {
  GA_TOYOTA_FOR_YOU_OVERLAY_PAGE,
  GaEvent,
} from "../../_common/modules/fe-modules/GA/static";
import { stringSplitByHyphen } from "../../_common/helpers/utils";
import useCMSPageData from "../../_common/hooks/useCMSPageData";
import { useDataContext } from "../../_common/modules/Data/DataProvider";
import { PAGE_ADVANTAGES } from "../../_common/modules/fe-modules/Router/static";

export type UseAdvantagesProps = {
  headerContent: any;
  mainContent: any;
  footerContent: any;
};

const useAdvantages = (): UseAdvantagesProps => {
  const { modalState } = useDataContext();
  const { triggerGAEvent } = useGA();

  const { data } = useCMSPageData({
    page: PAGE_ADVANTAGES,
    queryKey: "advantagesPage",
  });

  useGAViewScreen(GA_TOYOTA_FOR_YOU_OVERLAY_PAGE, modalState.data?.selectedId);
  // ********************
  // Helpers
  // ********************
  const getSwiperSlidesProps = useCallback(
    (rawItems: any) => {
      const initialIdx = modalState.data?.itemIds.indexOf(modalState.data?.selectedId);
      const orderedItems = modalState.data?.itemIds
        .map((id: string) => rawItems.find((item: any) => item?.props?.id === id))
        .filter(Boolean);

      return {
        initialIdx,
        items: orderedItems,
      };
    },
    [modalState.data],
  );

  // ********************
  // Data
  // ********************
  const getHeaderContent = useCallback(() => data?.containers?.header, [data]);

  const getMainContent = useCallback(
    () =>
      data?.containers?.main.map((component: any) => {
        if (component.type === UI_MOLECULE_SWIPER_SLIDES) {
          return {
            ...component,
            props: {
              ...component.props,
              qaId: QA_ADVANTAGES_MODAL_TAB,
              ...getSwiperSlidesProps(component.props.items),
              onActiveIndexChangeParent: (index: number) => {
                triggerGAEvent(GaEvent.CONFIGURATOR_SELECT_TAB, {
                  tabName: stringSplitByHyphen(modalState.params?.itemIds?.[index]),
                });
              },
            },
          };
        }
        return component;
      }),
    [data?.containers?.main, getSwiperSlidesProps, modalState.params, triggerGAEvent],
  );

  const getFooterContent = useCallback(() => data?.containers?.footer, [data]);

  return {
    headerContent: getHeaderContent(),
    mainContent: getMainContent(),
    footerContent: getFooterContent(),
  };
};

export default useAdvantages;
